<template>
    <div class="poll-block">
        <!-- Options are always tappable rows: before voting they read as
             choices, after voting they show WhatsApp-style result bars with
             your pick marked. Tapping another row changes your vote. -->
        <div
            class="poll-option"
            v-for="option in post.options"
            :key="option.id"
            :class="{'is-mine': post.my_vote === option.id, 'has-voted': hasVoted}"
            @click="vote(option)"
        >
            <div class="bar" v-if="hasVoted" :style="{width: percent(option) + '%'}"></div>
            <div class="option-row">
                <span class="option-label">
                    <i class="fas fa-check-circle mr-2" v-if="post.my_vote === option.id"></i>
                    <i class="far fa-circle mr-2" v-else></i>
                    {{ option.label }}
                </span>
                <span class="option-count" v-if="hasVoted">{{ option.votes }} · {{ percent(option) }}%</span>
            </div>
        </div>

        <div class="is-size-7 has-text-grey mt-2">
            {{ post.total_votes }} vote{{ post.total_votes === 1 ? '' : 's' }}
            <a class="ml-3" v-if="isStaff" @click="showBreakdown">
                <i class="fas fa-chart-bar mr-1"></i>View responses
            </a>
        </div>

        <b-modal v-model="breakdownOpen">
            <div class="card">
                <div class="card-header">
                    <p class="card-header-title"><i class="fal fa-chart-bar fa-fw mr-3"></i>Poll Responses</p>
                </div>
                <div class="card-content">
                    <div class="content mt-2 mb-2" v-if="breakdownLoading">
                        <h6 class="has-text-grey"><i class="fal fa-tennis-ball fa-spin mr-3"></i>Loading...</h6>
                    </div>
                    <div v-else>
                        <div v-for="option in post.options" :key="option.id" class="mb-4">
                            <h6 class="mb-2">{{ option.label }} <span class="has-text-grey">({{ votersFor(option.id).length }})</span></h6>
                            <p class="has-text-grey is-italic is-size-7" v-if="!votersFor(option.id).length">No votes</p>
                            <b-tag v-for="(voter, i) in votersFor(option.id)" :key="i" class="mr-2 mb-1">
                                {{ voterName(voter) }}
                            </b-tag>
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import {client as http} from '@/http_client';

    export default {
        name: 'PollBlock',
        props: {
            post: {type: Object, required: true},
            regId: {type: Number, required: true},
            isStaff: {type: Boolean, default: false}
        },
        data: function() {
            return {
                breakdownOpen: false,
                breakdownLoading: false,
                breakdown: []
            };
        },
        computed: {
            hasVoted: function() {
                // Staff see live results without voting; voters see them after.
                return this.post.my_vote !== null || this.isStaff;
            }
        },
        methods: {
            percent: function(option) {
                if (!this.post.total_votes) return 0;
                return Math.round(option.votes / this.post.total_votes * 100);
            },
            vote: function(option) {
                if (this.post.my_vote === option.id) return;
                http.post(
                    `/app/experience/${this.regId}/announcements/${this.post.id}/vote`,
                    {option_id: option.id},
                    {force: true}
                ).then(() => this.$emit('changed'));
            },
            showBreakdown: function() {
                this.breakdownOpen = true;
                this.breakdownLoading = true;
                http.get(`/app/experience/${this.regId}/announcements/${this.post.id}/votes`, {force: true}).then(response => {
                    this.breakdown = response.data.votes;
                    this.breakdownLoading = false;
                });
            },
            votersFor: function(optionId) {
                return this.breakdown.filter(v => v.option_id === optionId);
            },
            voterName: function(voter) {
                return voter.preferred_name || [voter.first_name, voter.last_name].filter(Boolean).join(' ') || 'Unknown';
            }
        }
    };
</script>

<style lang="scss" scoped>
    .poll-block {
        .poll-option {
            position: relative;
            border: 1px solid #ddd;
            border-radius: 0.4rem;
            margin-bottom: 0.4rem;
            cursor: pointer;
            overflow: hidden;

            &:hover {
                border-color: #628b21;
            }

            &.is-mine {
                border-color: #628b21;

                .option-label i {
                    color: #628b21;
                }
            }

            .bar {
                position: absolute;
                top: 0;
                left: 0;
                bottom: 0;
                background-color: rgba(98, 139, 33, 0.15);
                transition: width 0.3s ease;
            }

            .option-row {
                position: relative;
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 0.5rem 0.8rem;

                .option-count {
                    font-size: 0.8rem;
                    color: #7a7a7a;
                    white-space: nowrap;
                    margin-left: 0.8rem;
                }
            }
        }
    }
</style>
